import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Emoji } from 'emoji-picker-react';
import React from 'react';
import { Avatar } from 'react-daisyui';
import { useWorkspaceContext } from '../../../../providers/WorkspaceProvider/Workspace.context';
import { eTemplateTypeColors, eTemplateTypeNames } from '../../Agenda.enums';
import styles from '../../agenda.module.scss';
import { tAgendaTemplateRow } from '../../Agenda.types';
import { useAgendaTemplatesContext } from '../../hooks/agendaTemplateView.hook';
import { useCalendarContext } from '../Calendar/Calendar.hook';
import { GetInitialsName } from '../../../../utils/GetInitialsName';
import './TemplateRow.styles.scss';

export default function TemplateRow({
  template,
}: tAgendaTemplateRow): React.ReactElement {
  const { editTemplate } = useAgendaTemplatesContext();
  const { setShowDeleteTemplate, setSelectedTemplate } = useCalendarContext();
  const { workspaceInfo } = useWorkspaceContext();

  function getUserName() {
    if (workspaceInfo?.users) {
      const user = workspaceInfo.users[template.created_by ?? ''];
      return user?.name;
    }
    return '';
  }

  function getTemplateColor() {
    const color =
      eTemplateTypeColors[
        template.event_type as keyof typeof eTemplateTypeColors
      ];

    return `border-agenda-event-${color}` || 'border-neutral';
  }

  function getEventTypeName() {
    const name =
      eTemplateTypeNames[
        template.event_type as keyof typeof eTemplateTypeNames
      ];

    return name || 'N/A';
  }

  function askForDelete() {
    setShowDeleteTemplate(true);
    setSelectedTemplate(template);
  }

  return (
    <div
      key={template.id}
      className={`${styles.AgendaTemplateRow} ${getTemplateColor()}`}
    >
      <div className={styles.AgendaTemplateRow__EmojiContainer}>
        <Emoji size={20} unified={template.emoji} lazyLoad />
        <p>{template.name}</p>
      </div>
      <p className={styles.AgendaTemplateRow__EventName}>
        {' '}
        {getEventTypeName()}{' '}
      </p>
      <div className={styles.AgendaTemplateRow__UserContainer}>
        <Avatar
          letters={GetInitialsName(getUserName() || '')}
          src={undefined}
          size="xs"
          shape="circle"
          color="primary"
        />
        <p className={styles.AgendaTemplateRowSendReminder}>
          {' '}
          {getUserName()}{' '}
        </p>
      </div>

      <div className={styles.AgendaTemplateRow__ActionsContainer}>
        <PencilIcon
          onClick={() => {
            editTemplate(template);
          }}
          className={styles.AgendaRowEditIcon}
        />
        <TrashIcon
          className={styles.AgendaRowDeleteIcon}
          onClick={askForDelete}
        />
      </div>
    </div>
  );
}
